$(document).ready ->
  # we used jQuery 'keyup' to trigger the computation as the user type

  anyEmpty = (boxes) ->
    i = 0
    while i < boxes.length
      box = $(boxes[i])
      if !box.val()
        return true
      i++
    false

  $('[data-selector="varcost"]').keyup ->
    # initialize the sum (total price) to zero
    sum = 0
    # we use jQuery each() to loop through all the textbox with 'price' class
    # and compute the sum for each loop
    $('[data-selector="varcost"]').each ->
      sum += Number($(this).val())
      return
    # set the computed value to 'totalPrice' textbox
    $('#sumCosts').val sum
    return
  $('.conversion-form input[type="text"]').focus ->
    value = $(this).val()
    if value == '0'
      $(this).val ''
    return
  $('.conversion-form input[type="text"]').blur ->
    value = $(this).val()
    if value.length == 0
      $(this).val '0'
    return
  $('[data-action="calculateprofit"]').on 'click', ->
    `var totalSavings`
    `var appCosts`
    `var appCosts`
    `var totalCostsNet`
    `var totalCostsStandard`
    `var liabilityInsuranceStandard`
    `var directorsInsuranceStandard`
    `var glassInsuranceStandard`
    `var homeInsuranceStandard`
    `var energyCostsStandard`
    `var bankCostsStandard`
    `var totalCosts`
    `var managerCosts`
    `var liabilityInsurance`
    `var directorsInsurance`
    `var glassInsurance`
    `var homeInsurance`
    `var energyCosts`
    `var bankCosts`
    `var savingsBalance`
    `var sumAppartments`
    `var rebuildValue`
    if anyEmpty($('input[type="text"]'))
    else
      $(this).removeClass('hidden').addClass 'active'
      $('#totalSavings').fadeOut()
      rebuildValue = 0
      sumAppartments = 0
      savingsBalance = 0
      bankCosts = 0
      energyCosts = 0
      homeInsurance = 0
      glassInsurance = 0
      directorsInsurance = 0
      liabilityInsurance = 0
      managerCosts = 0
      totalCosts = 0
      bankCostsStandard = 0
      energyCostsStandard = 0
      homeInsuranceStandard = 0
      glassInsuranceStandard = 0
      directorsInsuranceStandard = 0
      liabilityInsuranceStandard = 0
      totalCostsStandard = 0
      totalCostsNet = 0
      appCosts = 0
      totalSavings = 0
      rebuildValue = $('#rebuildValue').val()
      sumAppartments = $('#sumAppartments').val()
      savingsBalance = $('#savingsBalance').val()
      bankCosts = $('#bankCosts').val()
      energyCosts = $('#energyCosts').val()
      homeInsurance = $('#homeInsurance').val()
      glassInsurance = $('#glassInsurance').val()
      directorsInsurance = $('#directorsInsurance').val()
      liabilityInsurance = $('#liabilityInsurance').val()
      managerCosts = $('#managerCosts').val()
      totalCosts = parseFloat(bankCosts) + parseFloat(energyCosts) + parseFloat(homeInsurance) + parseFloat(glassInsurance) + parseFloat(directorsInsurance) + parseFloat(liabilityInsurance) + parseFloat(managerCosts)
      bankCostsStandard = 70
      if energyCosts < 275
        energyCostsStandard = 30
      else
        energyCostsStandard = energyCosts
      homeInsuranceStandard = rebuildValue * 0.000425 * 1.21
      glassInsuranceStandard = 13.75 * sumAppartments * 1.21
      directorsInsuranceStandard = 80
      liabilityInsuranceStandard = 0.00008 * rebuildValue * 1.21
      if bankCosts < bankCostsStandard
        bankCosts = 0
        bankCostsStandard = 0
      if energyCosts < energyCostsStandard
        energyCosts = 0
        energyCostsStandard = 0
      if homeInsurance < homeInsuranceStandard
        homeInsurance = 0
        homeInsuranceStandard = 0
      if glassInsurance < glassInsuranceStandard
        glassInsurance = 0
        glassInsuranceStandard = 0
      if directorsInsurance < directorsInsuranceStandard
        directorsInsurance = 0
        directorsInsuranceStandard = 0
      if liabilityInsurance < liabilityInsuranceStandard
        liabilityInsurance = 0
        liabilityInsuranceStandard = 0
      totalCostsStandard = parseFloat(bankCostsStandard) + parseFloat(energyCostsStandard) + parseFloat(homeInsuranceStandard) + parseFloat(glassInsuranceStandard) + parseFloat(directorsInsuranceStandard) + parseFloat(liabilityInsuranceStandard)
      totalCostsNet = (parseFloat(totalCosts) - parseFloat(totalCostsStandard) + parseFloat(0.004 * savingsBalance)).toFixed(2)
      if sumAppartments * 3.5 * 12 > 420
        appCosts = 420
      else
        appCosts = (sumAppartments * 3.5 * 12).toFixed(2)
      totalSavings = (parseFloat(totalCostsNet) - parseFloat(appCosts)).toFixed(2)
      setTimeout (->
        $('[data-action="calculateprofit"]').removeClass('active').addClass('hidden').find('span').text 'Bereken besparing opnieuw'
        $('#savingsApp').text('').text totalCostsNet
        $('#costsApp').text('').text appCosts
        $('#netSavings').text('').text totalSavings
        $('#totalSavings').fadeIn()
        return
      ), 2000
    return
  return